import { render, staticRenderFns } from "./Ping.vue?vue&type=template&id=22324988&lang=pug"
import script from "./Ping.vue?vue&type=script&lang=js"
export * from "./Ping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports